import { ElementRef, Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class HeroService {
    private hero: ElementRef;

    constructor() {}

    public setHero(hero: ElementRef) {
        this.hero = hero;
    }

    public getHero(): ElementRef {
        return this.hero;
    }
}
